import { PatientOrderStatus } from './Patient.model'
import { deletePatient, updatePatient } from '../../../services/ApiService'
import { PatientSummaryDto } from '../../../types/swaggerTypes'

export enum PatientDeleteOutcome {
  PatientDeleted = 'PatientDeleted',
  PatientReset = 'PatientReset'
}

/**
 * Last step of the dashboard Delete flow, after the OPA and order are removed.
 * CLOS-14563: the BFF refuses DeletePatient for post-trial access patients, so
 * for them Delete means "delete this order and start again": the patient is
 * returned to Begin your order instead of being deleted.
 */
export const completePatientDelete = async (
  patient: Pick<PatientSummaryDto, 'patientId' | 'physicianId'>,
  isPostTrialAccess: boolean
): Promise<PatientDeleteOutcome> => {
  if (isPostTrialAccess) {
    await updatePatient(patient.physicianId, patient.patientId, {
      orderStatus: PatientOrderStatus.BeginOrder
    })
    return PatientDeleteOutcome.PatientReset
  }

  await deletePatient(patient.patientId.toString(), patient.physicianId)
  return PatientDeleteOutcome.PatientDeleted
}
